import styled from 'styled-components';

import Dropdown from 'react-bootstrap/Dropdown';

import { LuRuler, LuTrash, LuEllipsisVertical } from 'react-icons/lu';

import { useProject } from '@contexts/Project.context';

const DropdownToggle = styled(Dropdown.Toggle)`
	background: none;
	padding: 0 0 3px;
	font-size: 1.2rem;
	&.dropdown-toggle::after {
		display: none;
	}
`;

const DropdownMenu = styled(Dropdown.Menu)`
	svg {
		margin-right: 0.5rem;
	}
`;

const LayersDropdown = () => {
	return (
		<Dropdown>
			<DropdownToggle variant="dark">
				<LuEllipsisVertical />
			</DropdownToggle>
			<DropdownMenu variant="dark">
				<Measurement />
			</DropdownMenu>
		</Dropdown>
	);
};

export default LayersDropdown;

const Measurement = () => {
	const { measurementLayerAdded, dispatch } = useProject();

	const toggleMeasurementLayer = () => {
		dispatch({
			type: 'setMeasurementLayerAdded',
			payload: !measurementLayerAdded,
		});

		if (!measurementLayerAdded) {
			dispatch({
				type: 'setDialogue',
				payload: {
					header: 'Measurement Layer Added',
					body: (
						<>
							<p>Use the draw tools in the bottom toolbar.</p>
							<p>
								Note: The Measurement Layer is temporary and
								will not be saved. Any sketches made here will
								be lost if you refresh the page or remove the
								layer.
							</p>
						</>
					),
					dismissible: true,
				},
			});
		}
	};
	return (
		<Dropdown.Item as="button" onClick={toggleMeasurementLayer}>
			{measurementLayerAdded ? (
				<>
					<LuTrash />
					Remove Measurement Layer
				</>
			) : (
				<>
					<LuRuler />
					Add Measurement Layer
				</>
			)}
		</Dropdown.Item>
	);
};
